export default "__VITE_ASSET__BDaE54dD__"